import { Popconfirm } from 'antd';
import { useNavigate } from 'react-router-dom';
import { type FC } from 'react';
import { Button, Space } from '@g2u/ui-kit';
import { observer } from 'mobx-react-lite';

import { BookingStore } from 'store';
import { type WithOptionalDataTest } from 'types';
import { PopconfirmDescription } from 'components';

type Props = {
  active: boolean;
  isLoading: boolean;
  onNext: () => void;
} & WithOptionalDataTest;

export const Actions: FC<Props> = observer((props) => {
  const { active, onNext, isLoading } = props;
  const navigate = useNavigate();
  const { resetBookingProgress } = BookingStore;

  const handleLeaveBooking = () => {
    navigate('/dashboard');
    resetBookingProgress();
  };

  return (
    <Space.$ direction={Space.Direction.Horizontal} size={Space.Size.Small} justify={Space.Justify.End}>
      <Popconfirm title="Alert" onConfirm={handleLeaveBooking} description={<PopconfirmDescription />} okText="Yes">
        <div>
          <Button.$ dataTestId="page-back-btn" onClick={() => null} disabled={isLoading}>
            &lt; Back
          </Button.$>
        </div>
      </Popconfirm>

      <Popconfirm
        title="Alert"
        onConfirm={() => {
          handleLeaveBooking();
        }}
        description={<PopconfirmDescription />}
        okText="Yes"
      >
        <div>
          <Button.$ dataTestId="page-cancel-btn" danger onClick={() => null} disabled={isLoading}>
            Cancel this booking
          </Button.$>
        </div>
      </Popconfirm>

      <Button.$
        dataTestId="page-next-btn"
        disabled={!active}
        onClick={onNext}
        type={Button.Type.Primary}
        loading={isLoading}
      >
        Next (Select technician(s) & time) &gt;
      </Button.$>
    </Space.$>
  );
});
